'use strict';

var $ = require('jquery');
var offcanvasdialog = require('../components/offcanvasdialog');

module.exports = {
    init: function () {
        offcanvasdialog.init(
            'fylin-link-test-1',
            {
                overlay: true, // false | true | { backgroundColor: '#fff',  backgroundOpacity: 0..1 }
                closeOnClick: true, // true | false
                closeOnEsc: false, // true | false
                additionalClass: 'pageelements-flyin-1', // string with additional class name
                contentStyle: 'smashed', // smashed | pushed | overlaid
                layoutSideButton: false, // true | false
                preventScroll: true // true | false
            },
            null,
            $('.hidden-demo-content')
        );

        offcanvasdialog.init(
            'fylin-link-test-2',
            {
                overlay: true, // false | true | { backgroundColor: '#fff',  backgroundOpacity: 0..1 }
                closeOnClick: true, // true | false
                closeOnEsc: false, // true | false
                additionalClass: 'pageelements-flyin-2', // string with additional class name
                contentStyle: 'pushed', // smashed | pushed | overlaid
                layoutSideButton: false, // true | false
                preventScroll: true // true | false
            },
            null,
            $('.hidden-demo-content')
        );

        offcanvasdialog.init(
            'fylin-link-test-3',
            {
                overlay: true, // false | true | { backgroundColor: '#fff',  backgroundOpacity: 0..1 }
                closeOnClick: true, // true | false
                closeOnEsc: false, // true | false
                additionalClass: 'pageelements-flyin-3', // string with additional class name
                contentStyle: 'overlaid', // smashed | pushed | overlaid
                layoutSideButton: false, // true | false
                preventScroll: true // true | false
            },
            null,
            $('.hidden-demo-content')
        );

        offcanvasdialog.init(
            'fylin-link-test-4',
            {
                position: 'left',
                overlay: true, // false | true | { backgroundColor: '#fff',  backgroundOpacity: 0..1 }
                closeOnClick: true, // true | false
                closeOnEsc: false, // true | false
                additionalClass: 'pageelements-flyin-4', // string with additional class name
                contentStyle: 'smashed', // smashed | pushed | overlaid
                layoutSideButton: false, // true | false
                preventScroll: true // true | false
            },
            null,
            $('.hidden-demo-content')
        );

        offcanvasdialog.init(
            'fylin-link-test-5',
            {
                position: 'left',
                overlay: true, // false | true | { backgroundColor: '#fff',  backgroundOpacity: 0..1 }
                closeOnClick: true, // true | false
                closeOnEsc: false, // true | false
                additionalClass: 'pageelements-flyin-5', // string with additional class name
                contentStyle: 'pushed', // smashed | pushed | overlaid
                layoutSideButton: false, // true | false
                preventScroll: true // true | false
            },
            null,
            $('.hidden-demo-content')
        );

        offcanvasdialog.init(
            'fylin-link-test-6',
            {
                position: 'left',
                overlay: true, // false | true | { backgroundColor: '#fff',  backgroundOpacity: 0..1 }
                closeOnClick: true, // true | false
                closeOnEsc: false, // true | false
                additionalClass: 'pageelements-flyin-6', // string with additional class name
                contentStyle: 'overlaid', // smashed | pushed | overlaid
                layoutSideButton: false, // true | false
                preventScroll: true // true | false
            },
            null,
            $('.hidden-demo-content')
        );

        offcanvasdialog.init(
            'fylin-link-test-7',
            {
                position: 'left',
                headerStyle: 'over', // behind | over
                overlay: true, // false | true | { backgroundColor: '#fff',  backgroundOpacity: 0..1 }
                closeOnClick: true, // true | false
                closeOnEsc: false, // true | false
                additionalClass: 'pageelements-flyin-7', // string with additional class name
                contentStyle: 'pushed', // smashed | pushed | overlaid
                layoutSideButton: false, // true | false
                preventScroll: true // true | false
            },
            null,
            $('.hidden-demo-content')
        );

        offcanvasdialog.init(
            'fylin-link-test-8',
            {
                position: 'right',
                headerStyle: 'over', // behind | over
                overlay: true, // false | true | { backgroundColor: '#fff',  backgroundOpacity: 0..1 }
                closeOnClick: true, // true | false
                closeOnEsc: false, // true | false
                additionalClass: 'pageelements-flyin-8', // string with additional class name
                contentStyle: 'pushed', // smashed | pushed | overlaid
                layoutSideButton: false, // true | false
                preventScroll: true // true | false
            },
            null,
            $('.hidden-demo-content')
        );
    }
};
